import { render, staticRenderFns } from "./StudentTransferDetailPage.vue?vue&type=template&id=e99f1554&scoped=true"
import script from "./StudentTransferDetailPage.vue?vue&type=script&lang=js"
export * from "./StudentTransferDetailPage.vue?vue&type=script&lang=js"
import style0 from "./StudentTransferDetailPage.vue?vue&type=style&index=0&id=e99f1554&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e99f1554",
  null
  
)

export default component.exports